interface AppleProps {
    width?: number;
    height?: number;
    className?: string;
    [key: string]: any;
}

const Apple = (props: AppleProps) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M22.7333 27.04C21.4267 28.3067 20 28.1067 18.6267 27.5067C17.1733 26.8933 15.84 26.8667 14.3067 27.5067C12.3867 28.3333 11.3733 28.0933 10.2267 27.04C3.72 20.3333 4.68 10.12 12.0667 9.74667C13.8667 9.84 15.12 10.7333 16.1733 10.8133C17.7467 10.4933 19.2533 9.57333 20.9333 9.69333C22.9467 9.85333 24.4667 10.6533 25.4667 12.0933C21.3067 14.5867 22.2933 20.0667 26.1067 21.6C25.3467 23.6 24.36 25.5867 22.72 27.0533L22.7333 27.04ZM16.04 9.66667C15.84 6.69333 18.2533 4.24 21.0267 4C21.4133 7.44 17.9067 10 16.04 9.66667Z"
            fill="#5C6669"
        />
    </svg>
);
export default Apple;
